import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useSummonerSpells } from '../../hooks/useSummonerSpells';
export const SummonerSpellIcon = t0 => {
  const $ = _c(37);
  const {
    spellId,
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const className = t2 === undefined ? "" : t2;
  const {
    data: summonerSpells,
    isLoading,
    error
  } = useSummonerSpells();
  if (isLoading) {
    let t3;
    if ($[0] !== size) {
      t3 = {
        width: size,
        height: size,
        border: "1px solid #333",
        backgroundColor: "#2a2a2a"
      };
      $[0] = size;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== className || $[3] !== t3) {
      t4 = <div className={className} style={t3} />;
      $[2] = className;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (error || !summonerSpells) {
    let t3;
    if ($[5] !== size) {
      t3 = {
        width: size,
        height: size,
        border: "1px solid #333",
        backgroundColor: "#2a2a2a"
      };
      $[5] = size;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== className || $[8] !== t3) {
      t4 = <div className={className} style={t3} />;
      $[7] = className;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let spell;
  let t3;
  let t4;
  if ($[10] !== className || $[11] !== size || $[12] !== spellId || $[13] !== summonerSpells) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t5;
      if ($[17] !== spellId) {
        t5 = s => s.id === spellId;
        $[17] = spellId;
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      spell = summonerSpells.find(t5);
      if (!spell) {
        console.error(`Summoner spell not found for ID: ${spellId}`);
        let t6;
        if ($[19] !== size) {
          t6 = {
            width: size,
            height: size,
            border: "1px solid #333",
            backgroundColor: "#2a2a2a"
          };
          $[19] = size;
          $[20] = t6;
        } else {
          t6 = $[20];
        }
        let t7;
        if ($[21] !== className || $[22] !== t6) {
          t7 = <div className={className} style={t6} />;
          $[21] = className;
          $[22] = t6;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        t4 = t7;
        break bb0;
      }
      t3 = spell.iconPath.split("/").pop()?.toLowerCase() || "";
    }
    $[10] = className;
    $[11] = size;
    $[12] = spellId;
    $[13] = summonerSpells;
    $[14] = spell;
    $[15] = t3;
    $[16] = t4;
  } else {
    spell = $[14];
    t3 = $[15];
    t4 = $[16];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  const iconFileName = t3;
  const iconUrl = `https://raw.communitydragon.org/latest/game/data/spells/icons2d/${iconFileName}`;
  const t5 = `${spell.name} (${spellId})`;
  let t6;
  if ($[24] !== size) {
    t6 = {
      width: size,
      height: size,
      objectFit: "contain",
      border: "1px solid #333"
    };
    $[24] = size;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== iconUrl || $[27] !== spell.name || $[28] !== spellId) {
    t7 = e => {
      const target = e.target as HTMLImageElement;
      target.style.display = "none";
      console.error(`Failed to load summoner spell icon for ID: ${spellId}, name: ${spell.name} url: ${iconUrl}`);
    };
    $[26] = iconUrl;
    $[27] = spell.name;
    $[28] = spellId;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== className || $[31] !== iconUrl || $[32] !== size || $[33] !== t5 || $[34] !== t6 || $[35] !== t7) {
    t8 = <Image src={iconUrl} alt={t5} className={className} width={size} height={size} style={t6} onError={t7} />;
    $[30] = className;
    $[31] = iconUrl;
    $[32] = size;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
};